interface Props {
  isSelected: boolean;
  size?: number;
}

const RadioIcon = ({ isSelected, size = 22 }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      {isSelected ? (
        <>
          <rect width="22" height="22" rx="11" fill="#FF8D00" />
          <g clipPath="url(#clip0_3563_10811)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M15.9633 5.81434C15.7311 5.83188 15.525 5.92283 15.3653 6.07833C15.3414 6.1016 15.2744 6.17787 15.2164 6.24783C15.1584 6.31779 13.6716 8.11707 11.9124 10.2462C10.1532 12.3754 8.71046 14.1211 8.70622 14.1256C8.69906 14.1332 8.62878 14.0441 7.71451 12.8682C7.17331 12.1722 6.71258 11.5817 6.69067 11.556C6.53618 11.3752 6.32521 11.2669 6.07051 11.2377C5.77992 11.2043 5.50387 11.3007 5.28881 11.5105C5.20188 11.5954 5.142 11.6776 5.09396 11.7782C5.02658 11.9193 4.99631 12.0708 5.00156 12.2406C5.00779 12.4421 5.06386 12.6024 5.18713 12.771C5.21912 12.8148 7.29929 15.4897 7.35403 15.5574C7.40303 15.6181 7.5179 15.7339 7.57864 15.7838C8.0146 16.1423 8.57816 16.2696 9.12492 16.1332C9.45932 16.0498 9.77213 15.8577 10.0038 15.5934C10.0451 15.5463 16.7301 7.45765 16.7906 7.38168C16.8943 7.25127 16.9607 7.10534 16.9887 6.94623C17.0002 6.88034 17.0025 6.74017 16.9932 6.66412C16.9649 6.43292 16.8738 6.24853 16.7091 6.08927C16.5028 5.88987 16.241 5.79337 15.9633 5.81434Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_3563_10811">
              <rect
                width="12"
                height="12"
                fill="white"
                transform="translate(5 5)"
              />
            </clipPath>
          </defs>
        </>
      ) : (
        <rect
          x="1"
          y="1"
          width="20"
          height="20"
          rx="10"
          stroke="#DFE1E2"
          strokeWidth="2"
        />
      )}
    </svg>
  );
};

export default RadioIcon;
